import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

class AuthService {
  login(cellphone, password) {
    return axios
      .post(API_URL + "auth/login", {
        cellphone,
        password,
      })
      .then((response) => {
        if (response.data.token) {
          localStorage.setItem("user", JSON.stringify(response.data));
          // Dispatch custom event to notify components of login
          window.dispatchEvent(
            new CustomEvent("auth-change", { detail: { type: "login" } }),
          );
        }

        return response.data;
      });
  }

  requestOtp(cellphone) {
    return axios
      .post(API_URL + "auth/otp/send", { cellphone })
      .then((response) => response.data);
  }

  verifyOtp(cellphone, code) {
    return axios
      .post(API_URL + "auth/otp/verify", { cellphone, code })
      .then((response) => {
        if (response.data.token) {
          localStorage.setItem("user", JSON.stringify(response.data));
          // Dispatch custom event to notify components of login
          window.dispatchEvent(
            new CustomEvent("auth-change", { detail: { type: "login" } }),
          );
        }
        return response.data;
      });
  }

  verifyOtpOnly(phone_number, otp) {
    return axios
      .post(API_URL + "auth/otp/verify", { phone_number, otp })
      .then((response) => response.data);
  }

  sendRegistrationOtp(phone_number) {
    return axios
      .post(API_URL + "phone_verifications/send_code", { phone_number })
      .then((response) => response.data);
  }

  verifyRegistrationOtp(phone_number, code) {
    return axios
      .post(API_URL + "phone_verifications/verify_code", { phone_number, code })
      .then((response) => response.data);
  }

  logout() {
    localStorage.removeItem("user");
    // Dispatch custom event to notify components of logout
    window.dispatchEvent(
      new CustomEvent("auth-change", { detail: { type: "logout" } }),
    );
  }

  verifyEmail(confirmation_token) {
    return axios.post(API_URL + "auth/confirm_email/" + confirmation_token, {});
  }

  verifyNumber(verification_number) {
    return axios.post(
      API_URL + "auth/confirm_cellphone/" + verification_number,
      {},
    );
  }

  ResetPassword(password, reset_token) {
    return axios.post(API_URL + "auth/reset_password/" + reset_token, {
      password,
    });
  }

  ResetRequest(email, source = "parcelin") {
    return axios.post(API_URL + "auth/reset_password", {
      email,
      source,
    });
  }

  createBusiness(business) {
    return axios
      .post(API_URL + "businesses", business, { headers: authHeader() })
      .then((response) => response.data);
  }

  getBusiness(id) {
    return axios
      .get(API_URL + "businesses/" + id, { headers: authHeader() })
      .then((response) => response.data);
  }

  register(
    cellphone,
    first_name,
    last_name,
    role,
    gender,
    email,
    password,
    referral_key,
    source = 1,
  ) {
    return axios
      .post(API_URL + "users", {
        cellphone,
        first_name,
        last_name,
        role,
        email,
        gender,
        password,
        referral_key,
        source,
      })
      .then((response) => {
        if (response.data.token) {
          localStorage.setItem("user", JSON.stringify(response.data));
          // Dispatch custom event to notify components of login
          window.dispatchEvent(
            new CustomEvent("auth-change", { detail: { type: "login" } }),
          );
        }
        return response.data;
      })
      .catch((err) => {
        return err;
      });
  }

  update(cellphone, first_name, last_name, email, password) {
    return axios
      .patch(API_URL + "users", {
        cellphone,
        first_name,
        last_name,
        email,
        password,
        headers: authHeader,
      })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        return err;
      });
  }

  isLogin() {
    return JSON.parse(localStorage.getItem("user")) != null;
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  refreshUserWithBusiness(newBusiness) {
    const stored = this.getCurrentUser();
    if (stored) {
      const businesses = stored.user?.businesses ?? [];
      businesses.push(newBusiness);
      stored.user.businesses = businesses;
      localStorage.setItem("user", JSON.stringify(stored));
      window.dispatchEvent(
        new CustomEvent("auth-change", { detail: { type: "login" } }),
      );
    }
  }
}

export default new AuthService();
